import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;

// Temporary fix: Use the SERVICE_ROLE_KEY to bypass RLS and Auth issues 
// so the admin dashboard can insert categories and data without 401/403 errors.
// This is extracted from create_admin.mjs.
const serviceRoleKey = process.env.REACT_APP_SUPABASE_SERVICE_ROLE_KEY || 
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imp0eWpmZ3p4emlpZm5kem9xd25oIiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImlhdCI6MTc3NDI2NjA4MCwiZXhwIjoyMDg5ODQyMDgwfQ.usuVh0MNByjZpulFk1Y67Q8WzBKbrN-_W5D12qhreWU';

export const supabase = createClient(supabaseUrl, serviceRoleKey);
